.selectValue {
  display: flex;
  gap: 8px;
  align-items: center;
}
